import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { PdfViewerModule } from "ng2-pdf-viewer";

import { PhxDocumentViewerComponent } from "./phx-document-viewer.component";
import { PhxFileUploadModule } from "../file-upload/phx-file-upload.module";
import { PhxImagePanZoomModule } from "../image-pan-zoom/phx-image-pan-zoom.module";
import { PhxButtonGroupModule } from "../button-group/phx-button-group.module";
import { PhxButtonModule } from "../button/phx-button.module";
import { PhxIconButtonModule } from "../icon-button/phx-icon-button.module";
import { PhxIconModule } from "../icon/icon.module";
import { PhxDividerModule } from "../divider/phx-divider.module";
import { PhxTranslationsRootModule } from '../../translation/transloco-root.module';
import { PhxSpinnerModule } from "../spinner/phx-spinner.module";

@NgModule({
  declarations: [PhxDocumentViewerComponent],
  imports: [
    CommonModule,
    FormsModule,
    PdfViewerModule,
    PhxFileUploadModule,
    PhxImagePanZoomModule,
    PhxButtonGroupModule,
    PhxButtonModule,
    PhxIconButtonModule,
    PhxIconModule,
    PhxSpinnerModule,
    PhxDividerModule,
    PhxTranslationsRootModule
  ],
  exports: [PhxDocumentViewerComponent],
})
export class PhxDocumentViewerModule { }
